


















































































import {
  computed,
  ComputedRef,
  defineComponent,
  inject,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'

import DButton from '~/components/atoms/DS2/DButton'
import DSelectButton from '~/components/atoms/DS2/DSelectButton'
import SearchConditionSelectModalCassette from '~/components/organisms/DS2/SearchConditionSelectModal/components/SearchConditionSelectModalCassette'
import DModal from '~/components/molecules/DS2/DModal'
import ProIcon from '~/components/molecules/ProIcon'
import DSwitch from '~/components/atoms/DS2/DSwitch'

import { FACET_GROUP } from '~/components/organisms/DS2/ServiceSearchCondition/ServiceSearchCondition.vue'
import { ConditionOptionGroup } from '~/types/services/search'
import DivinationIcon from '~/components/molecules/Divination'

// 占いカテゴリ
const CATEGORY_DIVINATION_ID = 3

const searchConditionSelectModal = defineComponent({
  name: 'SearchConditionSelectModal',
  components: {
    DButton,
    DSelectButton,
    SearchConditionSelectModalCassette,
    DModal,
    ProIcon,
    DivinationIcon,
    DSwitch
  },
  props: {
    conditionOptionGroup: {
      type: Object as PropType<ConditionOptionGroup>,
      default: () => ({})
    },
    isSelectedCondition: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isConditionChanged: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isActive: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  setup(props, context) {
    const { conditionOptionGroup } = toRefs(props)
    const selectedCondition = inject('selectedSearchConditionAll')
    const parentCategoryId = inject<ComputedRef<number>>('parentCategoryId')
    const isPricesGroup = computed(() => conditionOptionGroup.value.key === FACET_GROUP.PRICES.key)
    const isAllGroup = computed(() => conditionOptionGroup.value.key === FACET_GROUP.ALL.key)
    const isDivinationCategory = computed(() => parentCategoryId.value === CATEGORY_DIVINATION_ID)

    function onClear(): void {
      context.emit('clear')
    }

    function onSearch(): void {
      context.emit('search')
    }

    function onChangeServiceKind(): void {
      context.emit('change-service-kind')
    }

    function closeModal(): void {
      context.emit('close')
    }

    return {
      isDivinationCategory,
      isPricesGroup,
      isAllGroup,
      onClear,
      onSearch,
      closeModal,
      onChangeServiceKind,
      selectedCondition
    }
  }
})

export default searchConditionSelectModal
